import { AdminReducer } from './AdminReducer';
import { AnalysesReducer } from './AnalysesReducer';
import { AnalysisReducer } from './AnalysisReducer';
import { AuthReducer } from './AuthReducer';
import { CustomerReducer } from './CustomerReducer';
import { CustomersReducer } from './CustomersReducer';
import { DocumentReducer } from './DocumentReducer';
import { MonitoredDocumentChangesReducer } from './MonitoredDocumentChangesReducer';
import { MonitoredDocumentCompareReducer } from './MonitoredDocumentCompareReducer';
import { MonitoredDocumentMarkdownReducer } from './MonitoredDocumentMarkdownReducer';
import { MonitoredDocumentReducer } from './MonitoredDocumentReducer';
import { MonitoredDocumentVersionReducer } from './MonitoredDocumentVersionReducer';
import { MonitoredDocumentVersionsReducer } from './MonitoredDocumentVersionsReducer';
import { QuestionMapReducer } from './QuestionMapReducer';
import { SearchReducer } from './SearchReducer';
import { UserReducer } from './UserReducer';
import { UsersReducer } from './UsersReducer';
import { combineReducers } from 'redux';

// EXPORT APP REDUCER
export const AppReducer = combineReducers({
    customers: CustomersReducer,
    customer: CustomerReducer,
    auth: AuthReducer,
    users: UsersReducer,
    user: UserReducer,
    document: DocumentReducer,
    monitoredDocumentChanges: MonitoredDocumentChangesReducer,
    monitoredDocument: MonitoredDocumentReducer,
    monitoredDocumentVersions: MonitoredDocumentVersionsReducer,
    monitoredDocumentVersion: MonitoredDocumentVersionReducer,
    markdown: MonitoredDocumentMarkdownReducer,
    monitoredDocumentCompare: MonitoredDocumentCompareReducer,
    analysis: AnalysisReducer,
    analyses: AnalysesReducer,
    search: SearchReducer,
    admin: AdminReducer,
    questionMap: QuestionMapReducer,
});
